import React from 'react';
import { Button, EmptyState, EmptyStateBody, EmptyStateHeader, EmptyStateIcon, EmptyStateVariant } from '@patternfly/react-core';
import { ExclamationCircleIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
const useStyles = createUseStyles({
    emptyStateUnavailable: {
        color: 'var(--pf-global--danger-color--100)',
        '& svg': { color: 'var(--pf-global--danger-color--100)' }
    },
    emptyStateLinkButton: {
        padding: '0',
    }
});
const UnavailableContent = ({ statusPageUrl = '', statusPageLinkText = 'status page', unavailableTitleText = 'This page is temporarily unavailable', unavailableBodyPreStatusLinkText = 'Try refreshing the page. If the problem persists, contact your organization administrator or visit our', unavailableBodyPostStatusLinkText = 'for known outages.' }) => {
    const classes = useStyles();
    return (React.createElement(EmptyState, { variant: EmptyStateVariant.lg, className: clsx(classes.emptyStateUnavailable) },
        React.createElement(EmptyStateHeader, { titleText: unavailableTitleText, icon: React.createElement(EmptyStateIcon, { icon: ExclamationCircleIcon }), headingLevel: "h5" }),
        React.createElement(EmptyStateBody, null,
            unavailableBodyPreStatusLinkText,
            ' ',
            React.createElement(Button, { component: 'a', className: clsx(classes.emptyStateLinkButton), variant: 'link', href: statusPageUrl, target: "_blank", rel: "noopener noreferrer" }, statusPageLinkText),
            ' ',
            unavailableBodyPostStatusLinkText)));
};
export default UnavailableContent;
